import { useMemo, useState, ReactNode } from 'react';
import AppLayout from '@cloudscape-design/components/app-layout';
import I18nProvider from '@cloudscape-design/components/i18n';
import enMessages from '@cloudscape-design/components/i18n/messages/all.en';
import { useAppSelector, useAppDispatch } from 'src/store/hooks';
import { setRegion } from 'src/store/slices/env/envSlice';
import { BeaconHeader } from './header/BeaconHeader';
import { AppRoutes } from './Routes';
import { GlobalNotifications } from 'src/components/common/GlobalNotifications';
import { SplitPanelContext, SplitPanelController } from './SplitPanelContext';

export const App = () => {
  const selectedRegion = useAppSelector(state => state.env.region);
  const dispatch = useAppDispatch();

  // Pages render into the layout's SplitPanel through SplitPanelContext.
  const [splitPanel, setSplitPanel] = useState<ReactNode | null>(null);
  const [splitPanelOpen, setSplitPanelOpen] = useState(false);
  const splitPanelController = useMemo<SplitPanelController>(
    () => ({ setSplitPanel, setSplitPanelOpen }),
    [],
  );

  return (
    <I18nProvider locale="en" messages={[enMessages]}>
      <SplitPanelContext.Provider value={splitPanelController}>
        <BeaconHeader
          selectedRegion={selectedRegion}
          onRegionChange={(id) => dispatch(setRegion(id))}
        />
        <AppLayout
          content={<AppRoutes />}
          notifications={<GlobalNotifications />}
          navigationHide
          toolsHide
          headerSelector="#beacon-header"
          maxContentWidth={Number.MAX_VALUE}
          splitPanel={splitPanel ?? undefined}
          splitPanelOpen={!!splitPanel && splitPanelOpen}
          onSplitPanelToggle={(e) => setSplitPanelOpen(e.detail.open)}
          splitPanelPreferences={{ position: 'side' }}
          onSplitPanelPreferencesChange={() => { /* fixed to side position */ }}
        />
      </SplitPanelContext.Provider>
    </I18nProvider>
  );
};
